<div class="modal-overlay" (click)="cancel()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Edit Session</h2>
      <button class="modal-close" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="edit-form">
        <!-- Track Selection -->
        <div class="form-group">
          <label for="track">Track</label>
          <div class="typeahead-container">
            <input
              id="track"
              type="text"
              [(ngModel)]="trackSearchQuery"
              (input)="filterTracks()"
              (focus)="onTrackInputFocus()"
              (blur)="onTrackInputBlur()"
              placeholder="Search for a track..."
              class="input-field"
            />
            <div
              *ngIf="showTrackDropdown && filteredTracks.length > 0"
              class="typeahead-dropdown"
            >
              <div
                *ngFor="let track of filteredTracks.slice(0, 50)"
                class="typeahead-item"
                (click)="selectTrack(track)"
              >
                {{ getTrackDisplay(track) }}
              </div>
            </div>
            <div
              *ngIf="
                showTrackDropdown &&
                trackSearchQuery &&
                filteredTracks.length === 0
              "
              class="typeahead-empty"
            >
              No tracks found
            </div>
          </div>
        </div>

        <!-- Laps Per Driver Selection -->
        <div class="form-group">
          <label for="lapsPerDriver">Laps Per Driver</label>
          <select
            id="lapsPerDriver"
            [(ngModel)]="lapsPerDriver"
            class="input-field"
          >
            <option *ngFor="let option of lapsPerDriverOptions" [ngValue]="option">
              {{ option }} laps
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="minIRating">Minimum iRating (Optional)</label>
          <input
            id="minIRating"
            type="number"
            min="0"
            [(ngModel)]="minIRating"
            class="input-field"
            placeholder="e.g. 1200"
          />
        </div>

        <div class="form-group">
          <label for="maxIRating">Maximum iRating (Optional)</label>
          <input
            id="maxIRating"
            type="number"
            min="0"
            [(ngModel)]="maxIRating"
            class="input-field"
            placeholder="e.g. 3000"
          />
        </div>

        <div class="form-group">
          <label for="startTime">Session Start (Optional)</label>
          <input
            id="startTime"
            type="datetime-local"
            [(ngModel)]="startTime"
            class="input-field"
          />
          <small class="help-text"
            >Session is live once current time reaches this start time.</small
          >
        </div>

        <div class="form-group">
          <label for="endTime">Session End (Optional)</label>
          <input
            id="endTime"
            type="datetime-local"
            [(ngModel)]="endTime"
            class="input-field"
          />
          <small class="help-text"
            >If set, session will end automatically at this time.</small
          >
        </div>

        <div class="form-group">
          <label class="checkbox-label">
            <input
              type="checkbox"
              [ngModel]="enforceStaticWeather"
              (ngModelChange)="toggleStaticWeatherEnforcement()"
            />
            Enforce static weather instead of default test drive weather
          </label>
          <small class="help-text">
            Telemetry must match this static weather setup before laps count.
          </small>
        </div>

        <div *ngIf="enforceStaticWeather">
          <div class="form-group">
            <label for="staticWeatherSkies">Skies</label>
            <select
              id="staticWeatherSkies"
              [(ngModel)]="staticWeatherSkies"
              class="input-field"
            >
              <option
                *ngFor="let option of staticWeatherSkyOptions"
                [ngValue]="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="staticTrackMoisture">Track Moisture</label>
            <select
              id="staticTrackMoisture"
              [(ngModel)]="staticTrackMoisture"
              class="input-field"
            >
              <option
                *ngFor="let option of staticTrackMoistureOptions"
                [ngValue]="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="staticAirTempC"
              >Temperature {{ formatTemperatureWithFahrenheit(staticAirTempC) }}</label
            >
            <input
              id="staticAirTempC"
              type="number"
              step="0.1"
              [(ngModel)]="staticAirTempC"
              class="input-field"
            />
          </div>

          <div class="form-group">
            <label for="staticRelativeHumidityPct">Humidity (%)</label>
            <input
              id="staticRelativeHumidityPct"
              type="number"
              min="0"
              max="100"
              step="0.1"
              [(ngModel)]="staticRelativeHumidityPct"
              class="input-field"
            />
          </div>

          <div class="form-group">
            <label for="staticWindSpeedMps">Wind Speed (m/s)</label>
            <input
              id="staticWindSpeedMps"
              type="number"
              min="0"
              step="0.1"
              [(ngModel)]="staticWindSpeedMps"
              class="input-field"
            />
          </div>

          <div class="form-group">
            <label for="staticWindDirection">Wind Direction</label>
            <select
              id="staticWindDirection"
              [(ngModel)]="staticWindDirection"
              class="input-field"
            >
              <option
                *ngFor="let option of staticWindDirectionOptions"
                [ngValue]="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>

        <!-- Car Class Restrictions (Optional) -->
        <div class="form-group">
          <label>Allowed Car Classes (Optional)</label>
          <div class="typeahead-container">
            <input
              type="text"
              [(ngModel)]="carSearchQuery"
              (input)="filterCars()"
              (focus)="onCarInputFocus()"
              (blur)="onCarInputBlur()"
              placeholder="Search for cars or car classes..."
              class="input-field"
            />
            <div
              *ngIf="showCarDropdown && filteredCars.length > 0"
              class="typeahead-dropdown car-dropdown"
            >
              <div
                *ngFor="let car of filteredCars"
                class="typeahead-item car-item"
                (click)="toggleCarClass(car.carName)"
              >
                <div class="car-name">{{ car.carName }}</div>
                <div
                  class="car-classes"
                  *ngIf="car.carClasses && car.carClasses.length > 0"
                >
                  <span
                    *ngFor="let cc of car.carClasses; let isLast = last"
                    class="car-class-badge"
                  >
                    {{ cc.carClass.shortName || cc.carClass.carName
                    }}{{ !isLast ? ", " : "" }}
                  </span>
                </div>
              </div>
            </div>
            <div
              *ngIf="
                showCarDropdown && carSearchQuery && filteredCars.length === 0
              "
              class="typeahead-empty"
            >
              No cars found
            </div>
          </div>

          <!-- Selected car classes chips -->
          <div *ngIf="selectedCarClasses.length > 0" class="selected-cars">
            <div
              class="car-class-chip selected"
              *ngFor="let carClass of selectedCarClasses"
            >
              {{ carClass }}
              <button
                type="button"
                class="remove-chip"
                (click)="toggleCarClass(carClass)"
              >
                ×
              </button>
            </div>
          </div>

          <small class="help-text"
            >Leave empty to allow all cars. Car will be detected from iRacing
            telemetry.</small
          >
        </div>

        <p *ngIf="error" class="error">{{ error }}</p>

        <div class="button-group">
          <button (click)="cancel()" class="btn btn-secondary-outline">
            Cancel
          </button>
          <button
            *ngIf="canMakeLiveNow"
            (click)="makeSessionLiveNow()"
            class="btn btn-warning-outline"
            [disabled]="saving"
          >
            Make Live Now
          </button>
          <button
            (click)="saveChanges()"
            class="btn btn-primary"
            [disabled]="saving"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
